import { render, staticRenderFns } from "./DialogConfirmUnsavedChanges.vue?vue&type=template&id=be27a254&scoped=true&"
import script from "./DialogConfirmUnsavedChanges.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmUnsavedChanges.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmUnsavedChanges.vue?vue&type=style&index=0&id=be27a254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be27a254",
  null
  
)

export default component.exports